import * as React from "react";
import {
  SimpleForm,
  TextInput,
  Edit,
  EditProps,
  BooleanInput,
  SelectInput,
  useEditController,
  useGetList,
} from "react-admin";
import { FieldValues } from "react-hook-form";

export const EditCategory: React.FC<EditProps> = (props) => {
  const { record, save } = useEditController(props);

  const { data: categories = [], isLoading: isLoadingCategories } = useGetList("categories", {
    filter: { isRoot: true },
    pagination: { page: 1, perPage: 100 },
  });

  const [isRootCategory, setIsRootCategory] = React.useState(
    record?.isRoot ?? false
  );

  const handleToggleIsRootCategory = React.useCallback(() => {
    setIsRootCategory((prev: boolean) => !prev);
  }, []);

  const handleSubmit = (values: FieldValues) => {
    if (!save) return;
    const data = {
      ...values,
      parentId: isRootCategory ? null : values.parentId,
    };
    save(data);
  };

  return (
    <Edit {...props} mutationMode="pessimistic">
      <SimpleForm onSubmit={handleSubmit}>
        <TextInput source="name" fullWidth required label="Nombre" />
        <BooleanInput
          source="isRoot"
          label="Es categoría padre"
          onChange={handleToggleIsRootCategory}
        />
        {!isRootCategory && (
          <SelectInput
            source="parentId"
            label="Categoría padre"
            choices={isLoadingCategories ? [] : categories}
            optionText="name"
            optionValue="id"
            fullWidth
            disabled={isLoadingCategories}
          ></SelectInput>
        )}
      </SimpleForm>
    </Edit>
  );
};
